import { render, staticRenderFns } from "./StudentViewStudentPermissionsCard.vue?vue&type=template&id=ecc0e2e2&"
import script from "./StudentViewStudentPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewStudentPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports